import { Box, Typography, Switch, Stack } from "@mui/material";
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchVirtualBatteryTypes } from "@/actions/bateriaVirtual";
import { IBateriaVirtual, IVirtualBatteryTypes } from './types/bateriaVirtual';
import { RootState } from "@/store";


export interface IVirtualBatteryDiscountToggleProps {
  bateriaVirtual: IBateriaVirtual,
  handleBatteryModeChange: (value: string, bateriaId: number) => void
}

const VirtualBatteryDiscountToggle = ({
  bateriaVirtual,
  handleBatteryModeChange
}: IVirtualBatteryDiscountToggleProps) => {

  const dispatch = useDispatch();
  const virtualBatteryTypes = useSelector((state: RootState) => state.bateriaVirtual.virtualBatteryTypes) as IVirtualBatteryTypes;

  useEffect(() => {
    if(!!virtualBatteryTypes){
      dispatch(fetchVirtualBatteryTypes());
    }
  }, []);

  return (
    <Stack direction="row">
      <Typography
        variant="body1"
        style={{
          color: bateriaVirtual.gestio_descomptes === "aplicar" ? "gray" : "black",
          marginTop: '6px'
        }}
      >
        No
      </Typography>

      <Switch
        checked={bateriaVirtual.gestio_descomptes === "aplicar"}
        onChange={(e) =>
          handleBatteryModeChange(
            e.target.checked
              ? virtualBatteryTypes.types[1].name //"aplicar"
              : virtualBatteryTypes.types[0].name, //"no_aplicar"
              bateriaVirtual.bateria.id
          )
        }
      />

      <Typography
        variant="body1"
        style={{
          color: bateriaVirtual.gestio_descomptes === "aplicar" ? "black" : "gray",
          marginTop: '6px'
        }}
      >
        Sí
      </Typography>
    </Stack>
  );
};

export default VirtualBatteryDiscountToggle;
